module.exports = __webpack_public_path__ + "static/BetMGM-002b03473a6e8f55799d5146664fa1d7.webp";